module.exports = __webpack_public_path__ + "static/media/sunnyvale3.8bee4c1d.jpg";